import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { fmtArgent } from '@/lib/lmdsDeductions';

// 🧾 Phase 3B (provisoire, repris dans Performance en Phase 4) : encadré « Classement de priorité {année} ».
export function ClassementPriorite({ classement, annee }) {
  return (
    <Card data-testid="encadre-classement-priorite">
      <CardHeader>
        <CardTitle className="text-base" data-testid="classement-titre">Classement de priorité {annee}</CardTitle>
        <p className="text-xs text-slate-500">1<sup>er</sup> critère : jours de fin de semaine admissibles · 2<sup>e</sup> : moyenne hebdomadaire de CA brut
          (semaines avec rapport). Les propriétaires n'y figurent jamais.</p>
      </CardHeader>
      <CardContent className="overflow-x-auto">
        {!classement.length ? <p className="text-sm text-slate-500" data-testid="classement-vide">Aucun participant.</p> : (
          <table className="w-full text-sm" data-testid="table-classement">
            <thead className="text-xs text-slate-500 text-left">
              <tr><th className="p-2">Rang</th><th className="p-2">Installateur</th><th className="p-2 text-right">Jours</th><th className="p-2 text-right">Moyenne / sem</th><th className="p-2">Explication</th></tr>
            </thead>
            <tbody>
              {classement.map((l) => (
                <tr key={l.installateur_id} className="border-t" data-testid={`classement-${l.installateur_id}`}>
                  <td className="p-2 font-bold" data-testid={`rang-${l.installateur_id}`}>{l.rang}</td>
                  <td className="p-2">{l.nom}</td>
                  <td className="p-2 text-right">{l.nb_jours_admissibles}</td>
                  <td className="p-2 text-right">{fmtArgent(l.moyenne_hebdo)}</td>
                  <td className="p-2 text-xs text-slate-600" data-testid={`explication-${l.installateur_id}`}>{l.explication}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </CardContent>
    </Card>
  );
}
